<template>
  <Menu
    id="user-actions"
    :button-aria-label="t('layouts.user_bar.my_account')"
    :button-classes="buttonClasses"
    :dropdown-classes="['right-0', 'left-auto']"
    class="hidden md:block"
  >
    <template #button>
      <AvatarIcon />
    </template>

    <template #listItems>
      <MenuItem>
        <button class="flex items-center space-x-3" @click="openTheme">
          <LzIcon path="icons/picture" size="md" class="text-primary" />
          <span class="text-primary text-md font-semibold">{{ t('layouts.user_bar.themes') }}</span>
        </button>
      </MenuItem>
      <MenuItem>
        <button class="flex items-center space-x-3" @click="openAvatar">
          <LzIcon path="icons/user" size="md" class="text-primary" />
          <span class="text-primary text-md font-semibold">{{ t('layouts.user_bar.avatars') }}</span>
        </button>
      </MenuItem>
      <MenuItem v-if="authorizedAsAdmin || authorizedAsSiteAdmin || authorizedAsMultiSiteViewer">
        <a class="flex items-center space-x-3" :href="Routes.site_admin_root_path()">
          <LzIcon path="icons/wrench" size="md" :class="isActive('/site_admin') ? 'text-accent' : 'text-primary'" />
          <span class="text-md font-semibold" :class="isActive('/site_admin') ? 'text-accent underline' : 'text-primary'">{{ t('common.admin') }}</span>
        </a>
      </MenuItem>
      <MenuItem v-if="authorizedAsCustomerAdmin">
        <a class="flex items-center space-x-3" :href="Routes.customers_url()">
          <LzIcon path="icons/rectangle-stack" size="md" :class="isActive('/sites') ? 'text-accent' : 'text-primary'" />
          <span class="text-md font-semibold" :class="isActive('/sites') ? 'text-accent underline' : 'text-primary'">{{ t('layouts.user_bar.customers') }}</span>
        </a>
      </MenuItem>
      <MenuItem>
        <a :href="Routes.edit_user_url()" class="flex items-center space-x-3">
          <LzIcon path="icons/cog" size="md" :class="isActive('/user/edit') ? 'text-accent' : 'text-primary'" />
          <span class="text-md font-semibold" :class="isActive('/user/edit') ? 'text-accent underline' : 'text-primary'">{{ t('layouts.user_bar.account_settings') }}</span>
        </a>
      </MenuItem>
      <MenuItem id="logout">
        <RailsForm :action="Routes.logout_path()" method="delete">
          <button
            type="submit"
            class="flex items-center space-x-2"
            data-test="logout-button"
            :data-logout-path="Routes.logout_path()"
          >
            <LzIcon path="icons/logout" size="md" class="text-primary" />
            <span class="text-primary text-md font-semibold">{{ t('common.logout') }}</span>
          </button>
        </RailsForm>
      </MenuItem>
    </template>
  </Menu>
</template>

<script setup>
import AvatarIcon from 'vue_features/avatars/components/images/AvatarIcon'
import { openModal } from 'vue_features/shared/composables/use_global_modals'
import { useCurrentUserStore } from 'vue_features/shared/store/composables'
import { LzIcon } from 'vue_features/shared/components/ui'
import Routes from 'routes'
import merge from 'lodash/merge'
import { common, layouts } from 'vue_features/shared/i18n'
import { namespaceLocaleObj } from 'vue_features/shared/helpers/i18n_helper'
import { useI18n } from 'vue-i18n'
import { RailsForm } from 'vue_features/shared/components/forms'
import { LzAnalytics } from '../../../clients'
import Menu from 'vue_features/shared/components/ui/Menu.vue'
import MenuItem from 'vue_features/shared/components/ui/MenuItem.vue'

const { authorizedAsAdmin, authorizedAsSiteAdmin, authorizedAsCustomerAdmin, authorizedAsMultiSiteViewer } = useCurrentUserStore()
const currentPath = window.location.pathname

function isActive(path) {
  return currentPath.startsWith(path)
}
const buttonClasses = [
  'rounded-full',
  'flex',
  'justify-center',
  'items-center',
  'bg-neutral-200',
  'cursor-pointer',
  'text-important',
  'hover:bg-neutral-500',
  'transition-colors',
  'h-12',
  'w-12',
  'shadow-none',
  'border-none',
  'md:block',
  'hidden',
  'p-0',
]
const messages = merge(
  {},
  namespaceLocaleObj(common, 'common', { only: ['admin', 'logout'] }),
  namespaceLocaleObj(layouts, 'layouts', { only: ['user_bar'] }),
)
const { t } = useI18n({ messages })
const openTheme = () => {
  openModal('ThemeModal')
  trackAnalytics('Theme Modal')
}
const openAvatar = () => {
  openModal('AvatarModal')
  trackAnalytics('Avatar Modal')
}

const trackAnalytics = (eventName) => {
  LzAnalytics.track(eventName, { source: 'header', action: 'open' })
}
</script>
